import { Media } from '@/src/models/MeidaDto';
import { CreditTemplateDto } from '@/src/models/CreditTemplateDto';
import { AdministratorDto } from '@/src/models/AdministratorDto';

export interface ChallengeInfo {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  contents: string;
}

export interface ChallengeCautions {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  contents: string;
}

export class ChallengeDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  startedAt: string;
  endedAt: string;
  isExposed: boolean;
  priorityDisplayYn: boolean;
  title: string;
  content: string;
  terminateStatus: string;
  thumbnailImage: Media;
  approveExampleImage: Media;
  rejectExampleImage: Media;
  creditTemplate: CreditTemplateDto;
  administrator: AdministratorDto;
  participantsCnt: number;
  challengeInfos: ChallengeInfo[];
  challengeCautions: ChallengeCautions[];

  constructor() {
    this.challengeInfos = [];
    this.challengeCautions = [];
  }
}
